import {
  Dimensions,
  FlatList,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Modal from 'react-native-modal';
import React, {useEffect} from 'react';
import {createStyles} from '../../../../utils/createStyles';

interface AreaListModalProps {
  visible: boolean;
  onBackdropPress: () => void;
  area: number;
  changeArea: (type: number) => void;
  areaList: Array<{
    examAreaId: number;
    Classify: number;
    name: string;
    fullName: string;
    OrderIndex: number;
    id: number;
    parentId: number;
  }>;
}

const AreaListModal: React.FC<AreaListModalProps> = ({
  visible,
  onBackdropPress,
  changeArea,
  area,
  areaList,
}) => {
  const deviceWidth = Dimensions.get('window').width;
  const deviceHeight =
    Platform.OS === 'ios'
      ? Dimensions.get('window').height
      : require('react-native-extra-dimensions-android').get(
          'REAL_WINDOW_HEIGHT',
        );
  useEffect(() => {
    if (visible) {
      console.log('112', area);
      setCurrentArea(area);
    }
  }, [visible]);
  const [currentArea, setCurrentArea] = React.useState<number>('all');
  return (
    <Modal
      style={{justifyContent: 'center', alignItems: 'center'}}
      isVisible={visible}
      animationIn={'bounceIn'}
      animationOut={'bounceOut'}
      onBackdropPress={onBackdropPress}
      deviceHeight={deviceHeight}
      deviceWidth={deviceWidth}>
      <View style={styles.ModalBox}>
        <View style={styles.ModalBoxMain}>
          <FlatList
            style={{width: '100%'}}
            data={areaList}
            renderItem={({item}) => {
              return (
                <TouchableOpacity
                  onPress={() => {
                    setCurrentArea(item.id);
                  }}
                  style={styles.ModalBoxMainItem}>
                  <Text
                    style={[
                      styles.ModalBoxMainItemText,
                      item.id === currentArea && {color: '#6658FF'},
                    ]}>
                    {item.name}
                  </Text>
                </TouchableOpacity>
              );
            }}
          />
        </View>
        <View style={styles.ModalBoxBtns}>
          <TouchableOpacity
            onPress={onBackdropPress}
            style={styles.ModalBoxBtnsItem}>
            <Text style={[styles.ModalBoxBtnsItemText, {color: '#6658FF'}]}>
              关闭
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              changeArea(currentArea);
              onBackdropPress();
            }}
            style={[styles.ModalBoxBtnsItem, {backgroundColor: '#6658FF'}]}>
            <Text style={[styles.ModalBoxBtnsItemText, {color: '#fff'}]}>
              确定
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};
const styles = createStyles({
  ModalBox: {
    width: '25.35rem',
    height: '31rem',
    backgroundColor: '#FFFFFF',
    borderRadius: '1rem',
    paddingHorizontal: '1.25rem',
    paddingVertical: '0.8rem',
  },
  ModalBoxMain: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1.95rem',
  },
  ModalBoxMainItem: {
    width: '100%',
    marginBottom: '1.85rem',
    alignItems: 'center',
  },
  ModalBoxMainItemText: {
    fontSize: '1.4rem',
    color: '#3D3D3D',
  },
  ModalBoxBtns: {
    width: '100%',
    height: '4rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '1.5rem',
  },
  ModalBoxBtnsItem: {
    width: '10.7rem',
    height: '4rem',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E2E2FF',
    borderRadius: '0.8rem',
  },
  ModalBoxBtnsItemText: {
    fontSize: '1.4rem',
  },
});
export default AreaListModal;
